
import logo from "../images/5A logo.png"
import hero from "../images/hero.png"
import h1 from "../images/h1.png"
import h2 from "../images/h2.png"
import h3 from "../images/h3.png"
import worker from "../images/worker.png"
import truck from "../images/truck.png"
import icon1 from "../images/icon1.png"
import icon2 from "../images/icon2.png"
import vector from "../images/Vector.png"
import service from "../images/service.png"
import formbg from "../images/formbg.png"
import dotedline from "../images/doted.png" 
import step1 from "../images/step1.png" 
import step2 from "../images/step2.svg" 
import step3 from "../images/step3.png" 
import step4 from "../images/step3.svg"
import client1 from "../images/Kimberly Hansen.png" 
import client2 from "../images/Miah Robbani.png" 
import footer from "../images/footer.png"
import logo2 from "../images/logo2.png"
import msg from "../images/msg.png"
import chat from "../images/chat.png"
import msgicon from "../images/msgicon.png"
import phoneicon from "../images/phoneicon.png"
import addressicon from "../images/address.png"
import blog1 from "../images/Blog1.jpg"
import blog2 from "../images/Blog2.jpg"
import blog3 from "../images/Blog3.jpg"
import fb from "../images/fb.png"
import insta from "../images/insta.png"
// import Twitter from "../images/Twitter.png"
import linkdin from "../images/linkdin.png"
import serviceicon from "../images/serviceicon.png"
import h1img from "../images/h1icon.png"
import h2icon from "../images/h2icon.png"
import optimized from "../images/optimized.png"
import delivery from "../images/delivery.png"
import safety from "../images/safety.png"
import arrow from "../images/arrow.png"
import img1 from "../images/img1.jpg"
import img2 from "../images/img2.jpg"
import img3 from "../images/img3.jpg"
import statsicon from "../images/stats.png"
import bg from "../images/bg.png"
import team from "../images/team.jpg"
import Banner from "../images/Banner-1.svg"
import smallicon from "../images/icon.svg"
import Banner4 from "../images/Banner-2.png"
import chaticon from "../images/chat icon.svg"
import layericon from "../images/Layer 2.svg"
import Banner1 from "../images/Banner-2.svg"
import Banner2 from "../images/Banner-3.svg"
import whybg from "../images/whybg.png"
import c1icon from "../images/cl.png"
import c2icon from "../images/c2.png"
import c3icon from "../images/c3.png"
import c4icon from "../images/c4.png"

const images ={
logo,
hero,
h1,
h2,
h3,
h1img,
h2icon,
worker,
truck,
icon1,
icon2,
vector,
service,
formbg,
dotedline,
step1,
step2,
step3,
step4,
client1,
client2,
footer,
logo2,
msg,
chat,
msgicon,
phoneicon,
addressicon,
blog1,
blog2,
blog3,
fb,
insta,
// Twitter,
linkdin,
serviceicon,
optimized,
delivery,
safety,
arrow,
img1,
img2,
img3,
statsicon,
bg,
team,
Banner,
Banner1,
Banner2,
smallicon,
Banner4,
chaticon,
layericon,
whybg,
c1icon,
c2icon,
c3icon,
c4icon,

}

export default images;